'use strict';

/** @type {import('./type')} */
module.exports = TypeError;



//////////////////
// WEBPACK FOOTER
// ../es-errors/type.js
// module id = 78
// module chunks = 0